import React from "react";
import "./Finore.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import AuroraAimages from "../../Media/Finore/Aurora A";
import AuroraBimages from "../../Media/Finore/Aurora B";
import AuroraCimages from "../../Media/Finore/Aurora C";
import AuroraDimages from "../../Media/Finore/Aurora D";

const imageMap = {
  AuroraAimages,
  AuroraBimages,
  AuroraCimages,
  AuroraDimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="finore" className="finore">
      <div className="bellefont">
        <h1>New Launching Summarecon Serpong</h1>
        <h2>Finore</h2>
      </div>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
